document.addEventListener('DOMContentLoaded', () => {
  const announcement = document.querySelector('[data-announcement]');
  if (announcement && announcement.children.length > 1) {
    window.setInterval(() => announcement.classList.toggle('is-alt'), 4200);
  }
  const purchaseToast = document.querySelector('.bq-purchase-toast');
  if (purchaseToast) window.setTimeout(() => purchaseToast.classList.add('is-hidden'), 10000);

  document.querySelectorAll('.bq-menu').forEach((menu) => {
    menu.addEventListener('toggle', () => document.body.classList.toggle('menu-open', menu.open));
    menu.querySelector('.bq-menu__close')?.addEventListener('click', () => {
      menu.removeAttribute('open');
      document.body.classList.remove('menu-open');
    });
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
      menu.removeAttribute('open');
      document.body.classList.remove('menu-open');
    }));
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    const activate = (index) => {
      if (!slides.length) return;
      activeIndex = ((Number(index) % slides.length) + slides.length) % slides.length;
      const activeKey = String(activeIndex);
      slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.gallerySlide === activeKey));
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb.dataset.galleryThumb === activeKey));
      thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => activate(thumb.dataset.galleryThumb)));
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => activate(activeIndex - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => activate(activeIndex + 1));
  });

  document.querySelectorAll('[data-variant-picker]').forEach((picker) => {
    const offers = [...picker.querySelectorAll('.bq-offer')];
    picker.querySelectorAll('[data-variant-input]').forEach((input) => {
      input.addEventListener('change', () => {
        offers.forEach((offer) => offer.classList.toggle('is-selected', offer.contains(input)));
      });
    });
  });

  document.querySelectorAll('[data-bundle-picker]').forEach((picker) => {
    const offers = [...picker.querySelectorAll('.bq-bundle-offer')];
    const quantityInput = picker.closest('form')?.querySelector('[data-bundle-quantity]');
    const selectOffer = (input) => {
      if (!input?.checked) return;
      offers.forEach((offer) => offer.classList.toggle('is-selected', offer.contains(input)));
      if (quantityInput) quantityInput.value = input.dataset.quantity || '1';
    };
    picker.querySelectorAll('[data-bundle-option]').forEach((input) => {
      input.addEventListener('change', () => selectOffer(input));
      if (input.checked) selectOffer(input);
    });
  });

  document.querySelectorAll('.bq-subscription-options').forEach((options) => {
    const cards = [...options.querySelectorAll('.bq-subscription-card, .bq-onetime-card')];
    cards.forEach((card) => {
      card.querySelector('input[type="radio"]')?.addEventListener('change', (event) => {
        if (!event.target.checked) return;
        cards.forEach((item) => item.classList.toggle('is-selected', item === card));
      });
    });
  });

  const getCartShell = () => document.querySelector('[data-cart-shell]');
  const withJsonExtension = (url) => url.endsWith('.js') ? url : `${url}.js`;
  let cartRequestPending = false;

  const updateCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.classList.toggle('is-empty', Number(count) === 0);
    });
  };

  const openCart = () => {
    const shell = getCartShell();
    if (!shell) return;
    shell.hidden = false;
    document.body.classList.add('cart-drawer-open');
    purchaseToast?.classList.add('is-hidden');
    window.requestAnimationFrame(() => {
      shell.classList.add('is-open');
      shell.querySelector('[data-cart-close]')?.focus({ preventScroll: true });
    });
  };

  const closeCart = () => {
    const shell = getCartShell();
    if (!shell) return;
    shell.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(() => {
      if (!shell.classList.contains('is-open')) shell.hidden = true;
    }, 360);
  };

  const showCartError = (message) => {
    const drawer = getCartShell()?.querySelector('.bq-cart-drawer');
    if (!drawer) return;
    drawer.querySelector('.bq-cart-error')?.remove();
    const error = document.createElement('p');
    error.className = 'bq-cart-error';
    error.textContent = message || 'Unable to update your cart. Please try again.';
    drawer.prepend(error);
  };

  const refreshCart = async (openAfter = true) => {
    const shell = getCartShell();
    if (!shell) return;
    const cartUrl = shell.dataset.cartUrl || '/cart';
    const separator = cartUrl.includes('?') ? '&' : '?';
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(`${cartUrl}${separator}sections=cart-drawer`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
      fetch(withJsonExtension(cartUrl), { headers: { Accept: 'application/json' } }),
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error('Unable to refresh cart');
    const sections = await sectionResponse.json();
    const cart = await cartResponse.json();
    const html = sections['cart-drawer'];
    if (!html) throw new Error('Cart drawer section did not render');
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const replacement = documentFragment.querySelector('[data-cart-shell]');
    if (!replacement) throw new Error('Cart drawer markup is missing');
    shell.replaceWith(replacement);
    updateCartCount(cart.item_count);
    if (openAfter) openCart();
  };

  const changeCartLine = async (line, quantity) => {
    if (cartRequestPending) return;
    const shell = getCartShell();
    if (!shell) return;
    cartRequestPending = true;
    shell.classList.add('is-loading');
    try {
      const response = await fetch(withJsonExtension(shell.dataset.cartChangeUrl || '/cart/change'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) }),
      });
      if (!response.ok) throw new Error('Unable to change quantity');
      await refreshCart(true);
    } catch (error) {
      showCartError(error.message);
      shell.classList.remove('is-loading');
    } finally {
      cartRequestPending = false;
    }
  };

  const updateCartMetadata = async (payload) => {
    const shell = getCartShell();
    if (!shell) return;
    try {
      const response = await fetch(withJsonExtension(shell.dataset.cartUpdateUrl || '/cart/update'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('Unable to save note');
    } catch (error) {
      showCartError(error.message);
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-cart-open]');
    if (openButton) {
      event.preventDefault();
      openCart();
      return;
    }

    const closeButton = event.target.closest('[data-cart-close]');
    if (closeButton) {
      event.preventDefault();
      closeCart();
      return;
    }

    const shell = getCartShell();
    if (shell && event.target === shell) {
      closeCart();
      return;
    }

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      changeCartLine(removeButton.dataset.line, 0);
      return;
    }

    const quantityButton = event.target.closest('[data-cart-quantity-minus], [data-cart-quantity-plus]');
    if (quantityButton) {
      event.preventDefault();
      const lineItem = quantityButton.closest('[data-cart-line]');
      const input = lineItem?.querySelector('[data-cart-quantity-input]');
      if (!input) return;
      const direction = quantityButton.hasAttribute('data-cart-quantity-plus') ? 1 : -1;
      changeCartLine(input.dataset.line, Math.max(0, Number(input.value) + direction));
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-quantity-input]')) {
      changeCartLine(event.target.dataset.line, event.target.value);
    } else if (event.target.matches('[data-cart-note]')) {
      updateCartMetadata({ note: event.target.value });
    } else if (event.target.matches('[data-cart-gift-note]')) {
      updateCartMetadata({ attributes: { 'Gift note': event.target.value } });
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.bq-pdp-form, .bq-quick-buy-form');
    if (!form) return;
    if (event.submitter?.classList.contains('shopify-payment-button__button')) return;
    event.preventDefault();
    const submitButton = event.submitter || form.querySelector('[type="submit"]');
    const originalText = submitButton?.innerHTML;
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || 'Unable to add this item');
      }
      await refreshCart(true);
    } catch (error) {
      openCart();
      showCartError(error.message);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        if (originalText != null) submitButton.innerHTML = originalText;
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && getCartShell()?.classList.contains('is-open')) closeCart();
  });

  if (document.body.classList.contains('template-cart')) window.setTimeout(openCart, 80);

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const selector = link.getAttribute('href');
      if (!selector || selector === '#') return;
      const target = document.querySelector(selector);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
